var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { getOktaToken } from "./auth/okta";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";
import { getApplicationConfig } from "../constants/utilities";
export var getAxios = function (config) { return __awaiter(void 0, void 0, Promise, function () {
    var oktaToken, instance;
    var _a, _b;
    return __generator(this, function (_c) {
        oktaToken = getOktaToken();
        instance = axios.create({
            baseURL: config.url,
            headers: config.url.includes(import.meta.env.VITE_API_URL_Market_SECURITY) ?
                {
                    "Content-Type": (_a = config.contentType) !== null && _a !== void 0 ? _a : "",
                    Accept: config.acceptHeader,
                    Authorization: "Bearer ".concat(oktaToken),
                    "X-Total-Count": config["xTotalCount"],
                    "Ocp-Apim-Subscription-Key": import.meta.env.APIM_SUBSCRIPTION_KEY
                } : {
                "Content-Type": (_b = config.contentType) !== null && _b !== void 0 ? _b : "",
                Accept: config.acceptHeader,
                Authorization: "Bearer ".concat(oktaToken),
                "X-Total-Count": config["xTotalCount"]
            }
        });
        instance.interceptors.response.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, config];
            });
        }); }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!error) return [3 /*break*/, 2];
                        if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401)) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleLogout()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 2];
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        return [2 /*return*/, instance];
    });
}); };
export var handleLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var oktaAuth, navigate, appConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                oktaAuth = useOktaAuth().oktaAuth;
                navigate = useNavigate();
                appConfig = getApplicationConfig();
                oktaAuth.tokenManager.clear();
                return [4 /*yield*/, oktaAuth.signOut({ postLogoutRedirectUri: "".concat(window.location.origin, "/callback") })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
